var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel full-page"},[_c('Navbar'),_c('div',{staticClass:"content"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }